import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";

/**
 * Generated class for the DialogCustomPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-dialog-custom',
  templateUrl: 'dialog-custom.html',
})
export class DialogCustomPage {

  public tag:string;
  public dialog_type:string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
              public translate:TranslateService
  ) {
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad DialogItemLookUpPage');
    this.dialog_type=this.navParams.get("dialog_type");
    this.tag=this.navParams.get("tag");
  }
  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/dialog-custom/dialog-custom.ts